import { useQuery } from 'react-query';

import { getCacheSettings } from 'common/helpers';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getRootCalculationStatusTypes } from 'modules/_common/api';

export const useQueryRootReservationStatuses = () => {
  const {
    error: errRootReservationStatuses,
    data: rootReservationStatuses,
    isLoading: isLoadingRootReservationStatuses,
  } = useQuery(
    [QUERY_KEYS.RENTALS_ROOT_CALCULATION_STATUS_TYPES],
    getRootCalculationStatusTypes,
    getCacheSettings(),
  );

  return {
    rootReservationStatuses,
    errRootReservationStatuses,
    isLoadingRootReservationStatuses,
  };
};
